import moment from 'moment'

export class GetToday {
  public execute(format = 'MM') {
    return moment().startOf('hours').format(format)
  }
}
